function ActionButtons({ disabled, onSubmit }) {
  return (
    <>
      <div className="d-flex mt-3 gap-2 position-relative">
        <button
          className="btn w-50"
          style={{ backgroundColor: "#DADBE0" }}
          onClick={() => window.history.back()}
        >
          Cancel
        </button>
        <button
          className="w-50 rounded-2 text-white"
          style={{ backgroundColor: !disabled ? "#14213D" : "#7887a7" }}
          onClick={onSubmit}
          disabled={disabled}
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default ActionButtons;
